import { SECTION_TYPE_GRANULARITY } from "@mui/x-date-pickers/internals/utils/getDefaultReferenceDate.js"
import Dashboard from "../pages/dashboard/index.jsx"
import {
    Login,
    Companies,
    DashBoard,
    CreateItemMaster,
    ItemMaster,
    ResetPassword,
    PurityMaster,
    CreateShapeMaster,
    CreateAccountMaster,
    AccountMaster,
    CreateMemoEntry,
    MemoEntryMaster,
    CreatePurityMaster,
    ShapeMaster,
    CreateModeSetting,
    CreateInvoiceMaster,
    MemoFinalizeEntry,
    InvoiceEntryMaster,
    CreateReturnEntry,
    ReturnEntryMaster,
    CreateShadeMaster,
    ShadeMaster,
    CreateCutMaster,
    CutMaster,
    CreateFlrnMaster,
    FlrnMaster,
    LWMaster,
    CreateSizeMaster,
    SizeMaster,
    CreateStockEntry,
    StockEntryMaster,
    MixSlitEntryMaster,
    CreateMixSlitEntry,
    CreateSingleMixSlitEntry,
    ReportViewer,
    CreateTempMaster,
    TransactionEntryMaster,
    CreateReceiveEntry,
    CreatePaymentEntry,
    OutRPartySummary,
    OutRPartyAgeSummary,
    OutRPartyDetail,
    OutPPartySummary,
    OutPPartyAgeSummary,
    OutPPartyDetail,
    Ledger,
    AccountLedger,
    MultiLedger,
    MultiAccountLedger,
    SalesData,
    SalesOrderSummary,
    Stock,
    MixStock,
    TradingReport,
    UploadStockParam,
    StockParamEntry,
    StockReport,
    UserCompnayMaping,
    OustandingReport,
    OutstandingBills,
    OutstandingBillEntry,
    PacketTransferMaster,
    PacketTransferEntry,
    MixPacketTransferMaster,
    MixPacketTransferEntry,
    GeneralPurchaseInvoiceMaster,
    CreateGeneralPurchaseInvoice,
    CreateItemGroupEntry,
    ItemGroupMaster,
    CreateItemTypeEntry,
    ItemTypeMaster,
    CreateImportExportEntry,
    ImportExportEntryMaster,
    CreateApiKeySetting,
    ApiKeyMaster,
    CreateRoughAllotmentEntry,
    RoughAllotmentMaster,
    StockTally,
    BarcodeGenerator,
    MainGst,
    GstLedger,
    GstPeriodicSummary,
    GstRegister,
    LotWisePositionReport,
    PacketInformationReport,
    SinglePktPriceUpdate,
    RoughStockReport,
    AssignTemplate,
    AssignTemplateMaster,
    ImportAccount,
    LotWiseDetail,

    SinglePktLotWiseStock,
    SinglePktLotWiseStockDetail,
    Authenticationkey,
    SinglePktInwardReport,
    LotCodeUpdate,
    CreditDebitNoteReport,
    TrailBalanceReport,
    ReceivePaymentReport,
    ProfitNLossReport,
    CreateLotEntry,
    LotMaster,
    JournalVoucherEntryMaster,
    CreateJournalVoucherEntry,
    LotWiseCostingReport,
    InvoiceReturnEntry,
    InvoiceReturnMaster,
    ParamWisePositionReport,

    PolishSizeMaster,
    PolishSizeMasterEntry,
    MemoReport,
    ImportBills,
    AccountSwapping,
    CreateDemand,
    DemandMaster,
    MonthlyClosing,
    CreateMonthlyClosing,
    CreateCrDrNote,
    CreditDebitNoteMaster,
    BankNCashBookReport,
    BillOfEntry,
    PriceListEntry

} from "../pages/index.js"
import { linksUrl } from "./enum.js"
import MixStockDetail from "../pages/stock/MixStockDetails.jsx"
import BalanceSheetReport from "../pages/sales/BalanceSheet.jsx"


export const menuPages = [
    {
        path: linksUrl.companies,
        component: <Companies />,
        name: "Companies",
    },
    {
        path: linksUrl.userCompMaping.get,
        component: <UserCompnayMaping />,
        name: "UserCompanyMaping",
    },
    {
        path: linksUrl.dashboard.tradingDashboard,
        component: <Dashboard />,
        name: "Dashboard",
    },

    {
        path: linksUrl.stockEntry.createStockEntry,
        component: <CreateStockEntry />,
        name: "Companies",
    },

    {
        path: linksUrl.resetPassword,
        component: <ResetPassword />,
        name: "Companies",
    },
    {
        path: linksUrl.report,
        component: <ReportViewer />,
        name: "Companies",
    },
    {
        path: linksUrl.master.item.itemMaster,
        component: <ItemMaster />,
        name: "ItemMaster",
    },
    {
        path: linksUrl.master.item.createItemMaster,
        component: <CreateItemMaster />,
        name: "ItemMaster",
    },
    {
        path: linksUrl.master.lot.createLotMaster,
        component: <CreateLotEntry />,
        name: "LotMasterEntry",
    },
    {
        path: linksUrl.master.lot.lotMaster,
        component: <LotMaster />,
        name: "LotMasterEntry",
    },
    {
        path: linksUrl.demand.createDemandMaster,
        component: <CreateDemand />,
        name: "DemandGeneration",
    },
    {
        path: linksUrl.demand.demandMaster,
        component: <DemandMaster />,
        name: "DemandGeneration",
    },

    {
        path: linksUrl.master.itemGroup.itemGroupMaster,
        component: <ItemGroupMaster />,
        name: "ItemGroupMaster",
    },
    {
        path: linksUrl.master.itemGroup.createItemGroupMaster,
        component: <CreateItemGroupEntry />,
        name: "ItemGroupMaster",
    },
    {
        path: linksUrl.master.itemType.itemTypeMaster,
        component: <ItemTypeMaster />,
        name: "ItemTypeMaster",
    },
    {
        path: linksUrl.master.itemType.createItemTypeMaster,
        component: <CreateItemTypeEntry />,
        name: "ItemTypeMaster",
    },
    {
        path: linksUrl.master.account.createAccountMaster,
        component: <CreateAccountMaster />,
        name: "AccountMaster",
    },
    {
        path: linksUrl.master.account.importAccount,
        component: <ImportAccount />,
        name: "AccountMaster",
    },
    {
        path: linksUrl.master.account.accountMaster,
        component: <AccountMaster />,
        name: "AccountMaster",
    },
    {
        path: linksUrl.utility.accountSwapping,
        component: <AccountSwapping />,
        name: "AccountSwapping",
    },
    {
        path: linksUrl.diamondParamater.shape.createShapeMaster,
        component: <CreateShapeMaster />,
        name: "ShapeMaster",
    },
    {
        path: linksUrl.diamondParamater.shape.shapeMaster,
        component: <ShapeMaster />,
        name: "ShapeMaster",
    },
    {
        path: linksUrl.diamondParamater.shade.createShadeMaster,
        component: <CreateShadeMaster />,
        name: "ShadeMaster",
    },
    {
        path: linksUrl.diamondParamater.shade.shadeMaster,
        component: <ShadeMaster />,
        name: "ShadeMaster",
    },
    {
        path: linksUrl.diamondParamater.purity.createPurityMaster,
        component: <CreatePurityMaster />,
        name: "PurityMaster",
    },
    {
        path: linksUrl.diamondParamater.purity.purityMaster,
        component: <PurityMaster />,
        name: "PurityMaster",
    },
    {
        path: linksUrl.diamondParamater.cut.createCutMaster,
        component: <CreateCutMaster />,
        name: "CutMaster",
    },
    {
        path: linksUrl.diamondParamater.cut.cutMaster,
        component: <CutMaster />,
        name: "CutMaster",
    },
    {
        path: linksUrl.diamondParamater.size.sizeMaster,
        component: <SizeMaster />,
        name: "SizeMaster",
    },

    {
        path: linksUrl.diamondParamater.size.createSizeMaster,
        component: <CreateSizeMaster />,
        name: "SizeMaster",
    },
    {
        path: linksUrl.diamondParamater.polishSize.polishSizeMaster,
        component: <PolishSizeMaster />,
        name: "PolishSizeMaster",
    },
    {
        path: linksUrl.diamondParamater.polishSize.createpolishSizeMaster,
        component: <PolishSizeMasterEntry />,
        name: "PolishSizeMaster",
    },
    {
        path: linksUrl.diamondParamater.lwmaster.LWMaster,
        component: <LWMaster />,
        name: "LWMaster"
    },
    {
        path: linksUrl.diamondParamater.flrn.flrnMaster,
        component: <FlrnMaster />,
        name: "FluorescentMaster",
    },
    {
        path: linksUrl.diamondParamater.flrn.createFlrnMaster,
        component: <CreateFlrnMaster />,
        name: "FluorescentMaster",
    },
    {
        path: linksUrl.memoEntry.memoEntryMaster + "/:btype/:trdtype/:ptype" + linksUrl.memoFinalizeEntry,
        component: <MemoFinalizeEntry />,
        name: "PurchaseMemoEntry",
    },
    {
        path: linksUrl.TemplateSettings.excelTemplateMap,
        component: <CreateTempMaster />,
        name: "TemplateSettings",
    },
    {
        path: linksUrl.authenticationkey,
        component: <Authenticationkey />,
        name: "AuthenticationKeySetting",
    },
    {
        path: linksUrl.modSetting.modSettingMaster,
        component: <CreateModeSetting />,
        name: "ModSettings",
    },
    {
        path: linksUrl.modSetting.importBills,
        component: <ImportBills />,
        name: "ImportBills",
    },
    {
        path: linksUrl.reportTemplate.createEntry,
        component: <AssignTemplate />,
        name: "ReportTemplate",
    },
    {
        path: linksUrl.reportTemplate.templateMaster,
        component: <AssignTemplateMaster />,
        name: "ReportTemplate",
    },
    //Stock Tally allotment
    {
        path: linksUrl.stockEntry.stockTally,
        component: <StockTally />,
        name: "StockTally",
    },
    //Stock UPDATE LOT PKT
    {
        path: linksUrl.stockEntry.updateLotCode,
        component: <LotCodeUpdate />,
        name: "UpdateLotCodePktNo",
    },
    {
        path: linksUrl.stockEntry.barcodeGenerator,
        component: <BarcodeGenerator />,
        name: "BarcodePrint",
    },

    //end stock telly
    //Gst Report
    {
        path: linksUrl.gstReport.mainGst,
        component: <MainGst />,
        name: "GstReport",

    },
    {
        path: linksUrl.gstReport.GstLedger,
        component: <GstLedger />,
        name: "GstReport",
    },
    {
        path: linksUrl.gstReport.GstPeriodicSummary,
        component: <GstPeriodicSummary />,
        name: "GstReport",
    },
    {
        path: linksUrl.gstReport.GstRegister,
        component: <GstRegister />,
        name: "GstReport",
    },
    //End Gst Report
    //rough allotment
    {
        path: linksUrl.roughAllotment.createAllotmentEntry,
        component: <CreateRoughAllotmentEntry />,
        name: "RoughAllotment",
    },
    {
        path: linksUrl.roughAllotment.allotmentEntryMaster,
        component: <RoughAllotmentMaster />,
        name: "RoughAllotment",
    },
    // end rough allotment

    //api key generate
    {
        path: linksUrl.clientApiEntry.createApiEntry,
        component: <CreateApiKeySetting />,
        name: "StockUploadApiKeySetting",
    },
    {
        path: linksUrl.clientApiEntry.apiEntryMaster,
        component: <ApiKeyMaster />,
        name: "StockUploadApiKeySetting",
    },

    //end
    // import export entry
    {
        path: linksUrl.importExportEntry.pay + "/:xtype" + linksUrl.importExportEntry.createPayEntry,
        component: <CreateImportExportEntry />,
        name: "PaymentAgainstImport",
    },
    {
        path: linksUrl.importExportEntry.pay + "/:xtype" + linksUrl.importExportEntry.payEntryMaster,
        component: <ImportExportEntryMaster />,
        name: "PaymentAgainstImport",
    },
    {
        path: linksUrl.importExportEntry.rec + "/:xtype" + linksUrl.importExportEntry.createRecEntry,
        component: <CreateImportExportEntry />,
        name: "ReceiveAgainstExport",
    },
    {
        path: linksUrl.importExportEntry.rec + "/:xtype" + linksUrl.importExportEntry.recEntryMaster,
        component: <ImportExportEntryMaster />,
        name: "ReceiveAgainstExport",
    },
    //end import export entry
    //GeneralPurchase
    //Invoice
    {
        path: linksUrl.invoiceEntry.genPurchaseEntryMaster,
        component: <GeneralPurchaseInvoiceMaster />,
        name: "GeneralPurchaseInvoiceEntry",

    },
    {
        path: linksUrl.invoiceEntry.createGenPurchaseEntry,
        component: <CreateGeneralPurchaseInvoice />,
        name: "GeneralPurchaseInvoiceEntry",

    },
    //end
    //packet transfer
    {
        path: linksUrl.packetTrasnferEntry.polishStock + "/:strdtype/:sptype" + linksUrl.packetTrasnferEntry.entrysingleMaster,
        component: <PacketTransferMaster />,
        name: "PolishPacketTrasnferSingle",
    },
    {
        path: linksUrl.packetTrasnferEntry.polishStock + "/:strdtype/:sptype" + linksUrl.packetTrasnferEntry.createsingleEntry,
        component: <PacketTransferEntry />,
        name: "PolishPacketTrasnferSingle",
    },

    {
        path: linksUrl.packetTrasnferEntry.roughStock + "/:strdtype/:sptype" + linksUrl.packetTrasnferEntry.entrysingleMaster,
        component: <PacketTransferMaster />,
        name: "RoughPacketTransferSingle",
    },
    {
        path: linksUrl.packetTrasnferEntry.roughStock + "/:strdtype/:sptype" + linksUrl.packetTrasnferEntry.createsingleEntry,
        component: <PacketTransferEntry />,
        name: "RoughPacketTransferSingle",
    },

    {
        path: linksUrl.packetTrasnferEntry.polishStock + "/:strdtype/:sptype" + linksUrl.packetTrasnferEntry.entrymixMaster,
        component: <MixPacketTransferMaster />,
        name: "PolishPacketTrasnferMix",
    },
    {
        path: linksUrl.packetTrasnferEntry.polishStock + "/:strdtype/:sptype" + linksUrl.packetTrasnferEntry.createmixEntry,
        component: <MixPacketTransferEntry />,
        name: "PolishPacketTrasnferMix",
    },

    {
        path: linksUrl.packetTrasnferEntry.roughStock + "/:strdtype/:sptype" + linksUrl.packetTrasnferEntry.entrymixMaster,
        component: <MixPacketTransferMaster />,
        name: "RoughPacketTransferMix",
    },
    {
        path: linksUrl.packetTrasnferEntry.roughStock + "/:strdtype/:sptype" + linksUrl.packetTrasnferEntry.createmixEntry,
        component: <MixPacketTransferEntry />,
        name: "RoughPacketTransferMix",
    },
    //end
    //CrDrNoteEntry
    {
        path: linksUrl.creditDebitEntry.createEntry,
        component: <CreateCrDrNote />,
        name: "CreditDebitNoteEntry",
    },
    {
        path: linksUrl.creditDebitEntry.crDrNoteMaster,
        component: <CreditDebitNoteMaster />,
        name: "CreditDebitNoteEntry",
    },
    //End CrDrNotr
    //stock report
    {
        path: linksUrl.stockEntry.getSingleStock + "/:stype",
        component: <Stock />,
        name: "StockReportSingle",
    },
    {
        path: linksUrl.stockEntry.getMixStock + "/:stype",
        component: <MixStock />,
        name: "StockReportMix",
    },
    {
        path: linksUrl.stockEntry.rptMixStockDetail,
        component: <MixStockDetail />,
        name: "StockReportMix",
    },
    {
        path: linksUrl.stockEntry.stockReport,
        component: <StockReport />,
        name: "SinglePacketStockView",
    },
    // end stock report
    //Final report
    {
        path: linksUrl.rptBankCashBook,
        component: <BankNCashBookReport />,
        name: "BankCashBookReport",
    },
    {
        path: linksUrl.rptDebitCreditNote,
        component: <CreditDebitNoteReport />,
        name: "DebitCreditNoteReport",
    },
    {
        path: linksUrl.rptBalanceSheet,
        component: <BalanceSheetReport />,
        name: "BalanceSheetReport",
    },
    {
        path: linksUrl.monthClosing.monthClosingStock,
        component: <CreateMonthlyClosing />,
        name: "MonthlyClosingEntry",
    },
    {
        path: linksUrl.rptTrialBalance,
        component: <TrailBalanceReport />,
        name: "TrialBalanceReport",
    },
    {
        path: linksUrl.rptProfitNLoss,
        component: <ProfitNLossReport />,
        name: "ProfitLossReport",
    },

    // end Final report
    //ledger
    {
        path: linksUrl.ledger.get,
        component: <Ledger />,
        name: "Ledgers",
    },
    {
        path: linksUrl.ledger.getAccount,
        component: <AccountLedger />,
        name: "Ledgers",
    },
    {
        path: linksUrl.multiCompLedger.get,
        component: <MultiLedger />,
        name: "Ledgers",
    },
    {
        path: linksUrl.multiCompLedger.getAccount,
        component: <MultiAccountLedger />,
        name: "Ledgers",
    },

    //end ledger
    {
        path: linksUrl.rptParamwisePosition,
        component: <ParamWisePositionReport />,
        name: "ParameterWiseStockSummary",
    },
    {
        path: linksUrl.rptLotwisePosition,
        component: <LotWisePositionReport />,
        name: "LotWisePositionReport",
    },
    {
        path: linksUrl.rptLotwiseDetail,
        component: <LotWiseDetail />,
        name: "LotWisePositionReport",
    },
    {
        path: linksUrl.rptSinglePktLotWiseStock,
        component: <SinglePktLotWiseStock />,
        name: "SinglePacketLotWiseStock",
    },
    {
        path: linksUrl.rptSinglePktInwardStock,
        component: <SinglePktInwardReport />,
        name: "SinglePacketInwardStock",
    },
    {
        path: linksUrl.rptSinglePktLotWiseStockDetail,
        component: <SinglePktLotWiseStockDetail />,
        name: "SinglePacketLotWiseStock",
    },
    {
        path: linksUrl.rptLotwiseCosting,
        component: <LotWiseCostingReport />,
        name: "LotwiseCostingReport",
    },
    {
        path: linksUrl.rptPacketInfo,
        component: <PacketInformationReport />,
        name: "PacketInformationReport",
    },
    {
        path: linksUrl.rptRoughStock,
        component: <RoughStockReport />,
        name: "RoughWiseStockReport",
    },
    {
        path: linksUrl.rptMemoDetail,
        component: <MemoReport />,
        name: "MemoListReport",
    },
    {
        path: linksUrl.salesData.getList,
        component: <TradingReport />,
        name: "TradingReport",
    },
    {
        path: linksUrl.salesOrder,
        component: <SalesOrderSummary />,
        name: "SalesOrderSummary",
    },
    //  outstamding
    {
        path: linksUrl.outstanding.receivable.partySummary,
        component: <OutRPartySummary />,
        name: "OutRecSummary",
    },
    {
        path: linksUrl.outstanding.receivable.partyAgingSummary,
        component: <OutRPartyAgeSummary />,
        name: "OutRecAgingSummary",
    },
    {
        path: linksUrl.outstanding.receivable.partyDetail,
        component: <OutRPartyDetail />,
        name: "OutRecDetail",
    },
    {
        path: linksUrl.outstanding.payable.partySummary,
        component: <OutPPartySummary />,
        name: "OutPaySummary",
    },
    {
        path: linksUrl.outstanding.payable.partyAgingSummary,
        component: <OutPPartyAgeSummary />,
        name: "OutPayAgindSummary",
    },
    {
        path: linksUrl.outstanding.payable.partyDetail,
        component: <OutPPartyDetail />,
        name: "OutPayDetail",
    },
    {
        path: linksUrl.outstanding.report,
        component: <OustandingReport />,
        name: "OutstandingReport",
    },
    // end outstanding
    {
        path: linksUrl.billOfEntry,
        component: <BillOfEntry />,
        name: "BillOfEntry",
    },
    {
        path: linksUrl.priceListEntry,
        component: <PriceListEntry />,
        name: "PolishPriceEntry",
    },
    {
        path: linksUrl.receiveEntry.receive + "/:etype" + linksUrl.receiveEntry.receiveEntryMaster,
        component: <TransactionEntryMaster />,
        name: "ReceiveEntry",
    },
    {
        path: linksUrl.receiveEntry.receive + "/:etype" + linksUrl.receiveEntry.createReceiveEntry,
        component: <CreateReceiveEntry />,
        name: "ReceiveEntry",
    },
    {
        path: linksUrl.paymentEntry.payment + "/:etype" + linksUrl.paymentEntry.paymentEntryMaster,
        component: <TransactionEntryMaster />,
        name: "PaymentEntry",
    },
    {
        path: linksUrl.paymentEntry.payment + "/:etype" + linksUrl.paymentEntry.createPaymentEntry,
        component: <CreatePaymentEntry />,
        name: "PaymentEntry",
    },
    {
        path: linksUrl.paymentEntry.paymentReport,
        component: <ReceivePaymentReport />,
        name: "PaymentReport",
    },
    {
        path: linksUrl.outstandingBillEntry.billEntryMaster,
        component: <OutstandingBills />,
        name: "OutstandingBillEntry",
    },
    {
        path: linksUrl.outstandingBillEntry.createBillEntry,
        component: <OutstandingBillEntry />,
        name: "OutstandingBillEntry",
    },
    {
        path: linksUrl.journalVoucherEntry.journalVoucherEntryMaster,
        component: <JournalVoucherEntryMaster />,
        name: "JournalVoucherEntry",
    },
    {
        path: linksUrl.journalVoucherEntry.createJournalVoucherEntry,
        component: <CreateJournalVoucherEntry />,
        name: "JournalVoucherEntry",
    },
    //-------MixSlit Single packet  Entry--------------

    {
        path: linksUrl.mixslitEntry.polishDiamond + ":mtrdtype/:mptype" + linksUrl.mixslitEntry.mixslitEntryMaster,
        component: <MixSlitEntryMaster />,
        name: "MixSlitPolishEntrySingle",
    },
    {
        path: linksUrl.mixslitEntry.roughDiamond + ":mtrdtype/:mptype" + linksUrl.mixslitEntry.mixslitEntryMaster,
        component: <MixSlitEntryMaster />,
        name: "MixSlitRoughEntrySingle",
    },
    {
        path: linksUrl.mixslitEntry.polishDiamond + ":mtrdtype/:mptype" + linksUrl.mixslitEntry.createMixslitEntry,
        component: <CreateSingleMixSlitEntry />,
        name: "MixSlitPolishEntrySingle",
    },
    {
        path: linksUrl.mixslitEntry.roughDiamond + ":mtrdtype/:mptype" + linksUrl.mixslitEntry.createMixslitEntry,
        component: <CreateSingleMixSlitEntry />,
        name: "MixSlitRoughEntrySingle",
    },
    //--- MixSlit  single Packet entry

    //-------MixSlit Mix packet  Entry--------------
    {
        path: linksUrl.mixslitEntry.roughDiamond + ":mtrdtype/:mptype" + linksUrl.mixEntry + linksUrl.mixslitEntry.mixslitEntryMaster,
        component: <MixSlitEntryMaster />,
        name: "MixSlitRoughEntryMix",
    },
    {
        path: linksUrl.mixslitEntry.polishDiamond + ":mtrdtype/:mptype" + linksUrl.mixEntry + linksUrl.mixslitEntry.mixslitEntryMaster,
        component: <MixSlitEntryMaster />,
        name: "MixSlitPolishEntryMix",
    },
    {
        path: linksUrl.mixslitEntry.polishDiamond + ":mtrdtype/:mptype" + linksUrl.mixEntry + linksUrl.mixslitEntry.createMixslitEntry,
        component: <CreateMixSlitEntry />,
        name: "MixSlitPolishEntryMix",
    },
    {
        path: linksUrl.mixslitEntry.roughDiamond + ":mtrdtype/:mptype" + linksUrl.mixEntry + linksUrl.mixslitEntry.createMixslitEntry,
        component: <CreateMixSlitEntry />,
        name: "MixSlitRoughEntryMix",
    },
    //--- MixSlit  Mix Packet entry

    //-------Stock Single packet  Entry--------------
    {
        path: linksUrl.stockEntry.roughDiamond + ":strdtype/:sptype" + linksUrl.stockEntry.stockEntryMaster,
        component: <StockEntryMaster />,
        name: "StockRoughEntrySingle",
    },

    {
        path: linksUrl.stockEntry.polishDiamond + ":strdtype/:sptype" + linksUrl.stockEntry.stockEntryMaster,
        component: <StockEntryMaster />,
        name: "StockPolishEntrySingle",
    },
    {
        path: linksUrl.stockEntry.polishDiamond + ":strdtype/:sptype" + linksUrl.stockEntry.parameterUpdate,
        component: <UploadStockParam />,
        name: "StockParameterUpdate",
    },
    {
        path: linksUrl.stockEntry.singlePktPriceUpdate,
        component: <SinglePktPriceUpdate />,
        name: "SinglePacketPriceUpdate",
    },
    {
        path: linksUrl.stockEntry.polishDiamond + ":strdtype/:sptype" + linksUrl.stockEntry.parameterUpdateEntry,
        component: <StockParamEntry />,
        name: "StockParameterUpdate",
    },

    {
        path: linksUrl.stockEntry.rejectDiamond + ":strdtype/:sptype" + linksUrl.stockEntry.stockEntryMaster,
        component: <StockEntryMaster />,
        name: "StockRejectionEntrySingle",
    },
    {
        path: linksUrl.stockEntry.rejectDiamond + ":strdtype/:sptype" + linksUrl.stockEntry.createStockEntry,
        component: <CreateStockEntry />,
        name: "StockRejectionEntrySingle",
    },
    {
        path: linksUrl.stockEntry.polishDiamond + ":strdtype/:sptype" + linksUrl.stockEntry.createStockEntry,
        component: <CreateStockEntry />,
        name: "StockPolishEntrySingle",
    },
    {
        path: linksUrl.stockEntry.roughDiamond + ":strdtype/:sptype" + linksUrl.stockEntry.createStockEntry,
        component: <CreateStockEntry />,
        name: "StockRoughEntrySingle",
    },

    //--- Stock  single Packet entry

    //-------Stock Mix packet  Entry--------------
    {
        path: linksUrl.stockEntry.roughDiamond + ":strdtype/:sptype" + linksUrl.mixEntry + linksUrl.stockEntry.stockEntryMaster,
        component: <StockEntryMaster />,
        name: "StockRoughEntryMix",
    },
    {
        path: linksUrl.stockEntry.polishDiamond + ":strdtype/:sptype" + linksUrl.mixEntry + linksUrl.stockEntry.stockEntryMaster,
        component: <StockEntryMaster />,
        name: "StockPolishEntryMix",
    },
    {
        path: linksUrl.stockEntry.rejectDiamond + ":strdtype/:sptype" + linksUrl.mixEntry + linksUrl.stockEntry.stockEntryMaster,
        component: <StockEntryMaster />,
        name: "StockRejectionEntryMix",
    },
    {
        path: linksUrl.stockEntry.rejectDiamond + ":strdtype/:sptype" + linksUrl.mixEntry + linksUrl.stockEntry.createStockEntry,
        component: <CreateStockEntry />,
        name: "StockRejectionEntryMix",
    },
    {
        path: linksUrl.stockEntry.polishDiamond + ":strdtype/:sptype" + linksUrl.mixEntry + linksUrl.stockEntry.createStockEntry,
        component: <CreateStockEntry />,
        name: "StockPolishEntryMix",
    },
    {
        path: linksUrl.stockEntry.roughDiamond + ":strdtype/:sptype" + linksUrl.mixEntry + linksUrl.stockEntry.createStockEntry,
        component: <CreateStockEntry />,
        name: "StockRoughEntryMix",
    },
    //--- Stock mix Packet entry
    //-------Sale Single Memo  Entry--------------
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.memoEntry.memoEntryMaster,
        component: <MemoEntryMaster />,
        name: "SaleRoughMemoEntrySingle",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.memoEntry.memoEntryMaster,
        component: <MemoEntryMaster />,
        name: "SalePolishMemoEntrySingle",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.memoEntry.memoEntryMaster,
        component: <MemoEntryMaster />,
        name: "SaleRejectionMemoEntrySingle",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.memoEntry.createMemoEntry,
        component: <CreateMemoEntry />,
        name: "SaleRejectionMemoEntrySingle",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.memoEntry.createMemoEntry,
        component: <CreateMemoEntry />,
        name: "SalePolishMemoEntrySingle",
    },
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.memoEntry.createMemoEntry,
        component: <CreateMemoEntry />,
        name: "SaleRoughMemoEntrySingle",
    },
    //-------------Emd Sale single Memo----------- 
    //-------------Sale Mix memo entry------------
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.memoEntry.memoEntryMaster,
        component: <MemoEntryMaster />,
        name: "SaleRoughMemoEntryMix",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.memoEntry.memoEntryMaster,
        component: <MemoEntryMaster />,
        name: "SalePolishMemoEntryMix",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.memoEntry.memoEntryMaster,
        component: <MemoEntryMaster />,
        name: "SaleRejectionMemoEntryMix",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry,
        component: <CreateMemoEntry />,
        name: "SaleRejectionMemoEntryMix",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry,
        component: <CreateMemoEntry />,
        name: "SalePolishMemoEntryMix",
    },
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry,
        component: <CreateMemoEntry />,
        name: "SaleRoughMemoEntryMix",
    },
    //-----------end sale mix memo----------------------
    //-----------Puchase Single Memo  Entry---------------
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.memoEntry.memoEntryMaster,
        component: <MemoEntryMaster />,
        name: "PurchaseRejectionMemoEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.memoEntry.memoEntryMaster,
        component: <MemoEntryMaster />,
        name: "PurchasePolishMemoEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.memoEntry.memoEntryMaster,
        component: <MemoEntryMaster />,
        name: "PurchaseRoughMemoEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.memoEntry.createMemoEntry,
        component: <CreateMemoEntry />,
        name: "PurchaseRejectionMemoEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.memoEntry.createMemoEntry,
        component: <CreateMemoEntry />,
        name: "PurchasePolishMemoEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.memoEntry.createMemoEntry,
        component: <CreateMemoEntry />,
        name: "PurchaseRoughMemoEntrySingle",
    },
    //---------End Purchase  single Memo-------------
    //----------Puchase Mix Memo  Entry--------------
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.memoEntry.memoEntryMaster,
        component: <MemoEntryMaster />,
        name: "PurchaseRejectionMemoEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.memoEntry.memoEntryMaster,
        component: <MemoEntryMaster />,
        name: "PurchasePolishMemoEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.memoEntry.memoEntryMaster,
        component: <MemoEntryMaster />,
        name: "PurchaseRoughMemoEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry,
        component: <CreateMemoEntry />,
        name: "PurchaseRejectionMemoEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry,
        component: <CreateMemoEntry />,
        name: "PurchasePolishMemoEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry,
        component: <CreateMemoEntry />,
        name: "PurchaseRoughMemoEntryMix",
    },
    //----------End Purchase mix Memo---------------------

    //-------Sale Single Invoice  Entry--------------
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.invoiceEntry.invoiceEntryMaster,
        component: <InvoiceEntryMaster />,
        name: "SaleRoughInvoiceEntrySingle",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.invoiceEntry.invoiceEntryMaster,
        component: <InvoiceEntryMaster />,
        name: "SalePolishInvoiceEntrySingle",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.invoiceEntry.invoiceEntryMaster,
        component: <InvoiceEntryMaster />,
        name: "SaleRejectionInvoiceEntrySingle",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.invoiceEntry.createInvoiceEntry,
        component: <CreateInvoiceMaster />,
        name: "SalePolishInvoiceEntrySingle",
    },
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.invoiceEntry.createInvoiceEntry,
        component: <CreateInvoiceMaster />,
        name: "SaleRoughInvoiceEntrySingle",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.invoiceEntry.createInvoiceEntry,
        component: <CreateInvoiceMaster />,
        name: "SaleRejectionInvoiceEntrySingle",
    },
    //-------------End Sale single Invoice-----------

    //-------Sale Mix Invoice  Entry--------------
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.invoiceEntry.invoiceEntryMaster,
        component: <InvoiceEntryMaster />,
        name: "SaleRoughInvoiceEntryMix",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.invoiceEntry.invoiceEntryMaster,
        component: <InvoiceEntryMaster />,
        name: "SalePolishInvoiceEntryMix",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.invoiceEntry.invoiceEntryMaster,
        component: <InvoiceEntryMaster />,
        name: "SaleRejectionInvoiceEntryMix",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.invoiceEntry.createInvoiceEntry,
        component: <CreateInvoiceMaster />,
        name: "SalePolishInvoiceEntryMix",
    },
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.invoiceEntry.createInvoiceEntry,
        component: <CreateInvoiceMaster />,
        name: "SaleRoughInvoiceEntryMix",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.invoiceEntry.createInvoiceEntry,
        component: <CreateInvoiceMaster />,
        name: "SaleRejectionInvoiceEntryMix",
    },
    //-------------Emd Sale Mix Invoice-----------

    //-----------Puchase Single Invoice Entry---------------
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.invoiceEntry.invoiceEntryMaster,
        component: <InvoiceEntryMaster />,
        name: "PurchaseRejectionInvoiceEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.invoiceEntry.invoiceEntryMaster,
        component: <InvoiceEntryMaster />,
        name: "PurchasePolishInvoiceEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.invoiceEntry.invoiceEntryMaster,
        component: <InvoiceEntryMaster />,
        name: "PurchaseRoughInvoiceEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.invoiceEntry.createInvoiceEntry,
        component: <CreateInvoiceMaster />,
        name: "PurchaseRejectionInvoiceEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.invoiceEntry.createInvoiceEntry,
        component: <CreateInvoiceMaster />,
        name: "PurchasePolishInvoiceEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.invoiceEntry.createInvoiceEntry,
        component: <CreateInvoiceMaster />,
        name: "PurchaseRoughInvoiceEntrySingle",
    },
    //---------End Purchase  single Invoice-------------
    //-----------Puchase Mix Invoice Entry---------------
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.invoiceEntry.invoiceEntryMaster,
        component: <InvoiceEntryMaster />,
        name: "PurchaseRejectionInvoiceEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.invoiceEntry.invoiceEntryMaster,
        component: <InvoiceEntryMaster />,
        name: "PurchasePolishInvoiceEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.invoiceEntry.invoiceEntryMaster,
        component: <InvoiceEntryMaster />,
        name: "PurchaseRoughInvoiceEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.invoiceEntry.createInvoiceEntry,
        component: <CreateInvoiceMaster />,
        name: "PurchaseRejectionInvoiceEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.invoiceEntry.createInvoiceEntry,
        component: <CreateInvoiceMaster />,
        name: "PurchasePolishInvoiceEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.invoiceEntry.createInvoiceEntry,
        component: <CreateInvoiceMaster />,
        name: "PurchaseRoughInvoiceEntryMix",
    },
    //---------End Purchase  Mix Invoice-------------


    //-------Sale  Single Packet Return Enrty--------------
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.returnEntryMaster,
        component: <ReturnEntryMaster />,
        name: "SaleRoughReturnEntrySingle",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.returnEntryMaster,
        component: <ReturnEntryMaster />,
        name: "SalePolishReturnEntrySingle",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.returnEntryMaster,
        component: <ReturnEntryMaster />,
        name: "SaleRejectionReturnEntrySingle",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.createReturnEntry,
        component: <CreateReturnEntry />,
        name: "SalePolishReturnEntrySingle",
    },
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.createReturnEntry,
        component: <CreateReturnEntry />,
        name: "SaleRoughReturnEntrySingle",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.createReturnEntry,
        component: <CreateReturnEntry />,
        name: "SaleRejectionReturnEntrySingle",
    },
    //-------------End Sale  single  Packet Return-----------
    //-------Sale  Single Packet  Invoice Return  Enrty--------------
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.invoiceReturnEntryMaster,
        component: <InvoiceReturnMaster />,
        name: "SaleRoughReturnEntrySingle",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.invoiceReturnEntryMaster,
        component: <InvoiceReturnMaster />,
        name: "SalePolishReturnEntrySingle",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.invoiceReturnEntryMaster,
        component: <InvoiceReturnMaster />,
        name: "SaleRejectionReturnEntrySingle",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.createInvoiceReturnEntry,
        component: <InvoiceReturnEntry />,
        name: "SalePolishReturnEntrySingle",
    },
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.createInvoiceReturnEntry,
        component: <InvoiceReturnEntry />,
        name: "SaleRoughReturnEntrySingle",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.createInvoiceReturnEntry,
        component: <InvoiceReturnEntry />,
        name: "SaleRejectionReturnEntrySingle",
    },
    //-------------End Sale  single  Packet Invoice Return-----------

    //-------Sale Mix Return  Entry--------------
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.returnEntryMaster,
        component: <ReturnEntryMaster />,
        name: "SaleRoughReturnEntryMix",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.returnEntryMaster,
        component: <ReturnEntryMaster />,
        name: "SalePolishReturnEntryMix",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.returnEntryMaster,
        component: <ReturnEntryMaster />,
        name: "SaleRejectionReturnEntryMix",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.createReturnEntry,
        component: <CreateReturnEntry />,
        name: "SalePolishReturnEntryMix",
    },
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.createReturnEntry,
        component: <CreateReturnEntry />,
        name: "SaleRoughReturnEntryMix",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.createReturnEntry,
        component: <CreateReturnEntry />,
        name: "SaleRejectionReturnEntryMix",
    },
    //-------------Emd Sale Mix Return Entry---------
    //-------Sale Mix Invoice Return  Entry--------------
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.invoiceReturnEntryMaster,
        component: <InvoiceReturnMaster />,
        name: "SaleRoughReturnEntryMix",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.invoiceReturnEntryMaster,
        component: <InvoiceReturnMaster />,
        name: "SalePolishReturnEntryMix",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.invoiceReturnEntryMaster,
        component: <InvoiceReturnMaster />,
        name: "SaleRejectionReturnEntryMix",
    },
    {
        path: linksUrl.saleEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.createInvoiceReturnEntry,
        component: <InvoiceReturnEntry />,
        name: "SalePolishReturnEntryMix",
    },
    {
        path: linksUrl.saleEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.createInvoiceReturnEntry,
        component: <InvoiceReturnEntry />,
        name: "SaleRoughReturnEntryMix",
    },
    {
        path: linksUrl.saleEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.createInvoiceReturnEntry,
        component: <InvoiceReturnEntry />,
        name: "SaleRejectionReturnEntryMix",
    },
    //-------------Emd Sale Mix Invoice Return Entry---------

    //-------Purchase  Single Packet Return Enrty--------------
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.returnEntryMaster,
        component: <ReturnEntryMaster />,
        name: "PurchaseRoughReturnEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.returnEntryMaster,
        component: <ReturnEntryMaster />,
        name: "PurchasePolishReturnEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.returnEntryMaster,
        component: <ReturnEntryMaster />,
        name: "PurchaseRejectionReturnEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.createReturnEntry,
        component: <CreateReturnEntry />,
        name: "PurchasePolishReturnEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.createReturnEntry,
        component: <CreateReturnEntry />,
        name: "PurchaseRoughReturnEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.createReturnEntry,
        component: <CreateReturnEntry />,
        name: "PurchaseRejectionReturnEntrySingle",
    },
    //-------------End Purchase  single  Packet Return-----------

    //-------Purchase  Single Packet invoice Return Enrty--------------
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.invoiceReturnEntryMaster,
        component: <InvoiceReturnMaster />,
        name: "PurchaseRoughReturnEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.invoiceReturnEntryMaster,
        component: <InvoiceReturnMaster />,
        name: "PurchasePolishReturnEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.invoiceReturnEntryMaster,
        component: <InvoiceReturnMaster />,
        name: "PurchaseRejectionReturnEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.createInvoiceReturnEntry,
        component: <InvoiceReturnEntry />,
        name: "PurchasePolishReturnEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.createInvoiceReturnEntry,
        component: <InvoiceReturnEntry />,
        name: "PurchaseRoughReturnEntrySingle",
    },
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.returnEntry.createInvoiceReturnEntry,
        component: <InvoiceReturnEntry />,
        name: "PurchaseRejectionReturnEntrySingle",
    },
    //-------------End Purchase  single  Packet Invoice Return-----------

    //-------Purchase Mix Return  Entry--------------
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.returnEntryMaster,
        component: <ReturnEntryMaster />,
        name: "PurchaseRoughReturnEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.returnEntryMaster,
        component: <ReturnEntryMaster />,
        name: "PurchasePolishReturnEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.returnEntryMaster,
        component: <ReturnEntryMaster />,
        name: "PurchaseRejectionReturnEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.createReturnEntry,
        component: <CreateReturnEntry />,
        name: "PurchasePolishReturnEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.createReturnEntry,
        component: <CreateReturnEntry />,
        name: "PurchaseRoughReturnEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.createReturnEntry,
        component: <CreateReturnEntry />,
        name: "PurchaseRejectionReturnEntryMix",
    },
    //-------------Emd Purchase Mix Return Entry---------
    //-------Purchase Mix Return invoice  Entry--------------
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.invoiceReturnEntryMaster,
        component: <InvoiceReturnMaster />,
        name: "PurchaseRoughReturnEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.invoiceReturnEntryMaster,
        component: <InvoiceReturnMaster />,
        name: "PurchasePolishReturnEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.invoiceReturnEntryMaster,
        component: <InvoiceReturnMaster />,
        name: "PurchaseRejectionReturnEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.polishDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.createInvoiceReturnEntry,
        component: <InvoiceReturnEntry />,
        name: "PurchasePolishReturnEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.roughDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.createInvoiceReturnEntry,
        component: <InvoiceReturnEntry />,
        name: "PurchaseRoughReturnEntryMix",
    },
    {
        path: linksUrl.purchaseEntry.rejectDiamond + ":btype/:trdtype/:ptype" + linksUrl.mixEntry + linksUrl.returnEntry.createInvoiceReturnEntry,
        component: <InvoiceReturnEntry />,
        name: "PurchaseRejectionReturnEntryMix",
    },
    //-------------Emd Purchase Mix Invoice Return Entry---------

]